import { useEffect, useState } from 'react';
import { useRevealOnScroll } from '@/hooks/useRevealOnScroll';
import SiteNav from '@/pages/home/components/SiteNav';
import Hero from '@/pages/home/components/Hero';
import OverviewSection from '@/pages/home/components/OverviewSection';
import StorySection from '@/pages/home/components/StorySection';
import CharactersSection from '@/pages/home/components/CharactersSection';
import EpisodesSection from '@/pages/home/components/EpisodesSection';
import ThemesSection from '@/pages/home/components/ThemesSection';
import ReviewsSection from '@/pages/home/components/ReviewsSection';
import WatchSection from '@/pages/home/components/WatchSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  useRevealOnScroll();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <OverviewSection />
        <StorySection />
        <CharactersSection />
        <EpisodesSection />
        <ThemesSection />
        <ReviewsSection />
        <WatchSection />
        <FaqSection />
      </main>
      <SiteFooter />

      {showTop ? (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="回到页面顶部"
          className="fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600 md:bottom-8 md:right-8"
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
        </button>
      ) : null}
    </div>
  );
}